import {
  AppInventoryOption,
  type AppInventoryOptionType,
  type AppInventoryState,
} from '@openx/types/targeting/appInventory';
import { type ComparisonType, Criteria, type CriteriaValue } from '@openx/types/targeting/targetingValuesTypes';
import { createAction } from '@reduxjs/toolkit';

const SET_CONTENT = 'SET_CONTENT';
const RESET_CONTENT = 'RESET_CONTENT';
const RESET_FILTER = 'RESET_FILTER';
const SET_COMPARISON_OP_VALUE = 'SET_COMPARISON_OP_VALUE';
const SET_CONTENT_CATEGORY_OP = 'SET_CONTENT_CATEGORY_OP';

export const setContent = createAction<AppInventoryState>(SET_CONTENT);
export const resetContent = createAction<AppInventoryState>(RESET_CONTENT);
export const resetFilter = createAction<{ contentOption: AppInventoryOptionType }>(RESET_FILTER);

export const setComparisonOpValue = {
  [AppInventoryOption.APP_BUNDLE_ID]: createAction<{
    values?: string[];
    comparisonType: ComparisonType;
    inventorylist_id?: string;
  }>(`${SET_COMPARISON_OP_VALUE}/${AppInventoryOption.APP_BUNDLE_ID}`),
  [AppInventoryOption.APP_GROUP]: createAction<{
    values: string[];
    comparisonType: ComparisonType;
  }>(`${SET_COMPARISON_OP_VALUE}/${AppInventoryOption.APP_GROUP}`),
};

export const setContentCategoryOp = {
  [AppInventoryOption.APP_BUNDLE_ID]: createAction<CriteriaValue>(
    `${SET_CONTENT_CATEGORY_OP}/${AppInventoryOption.APP_BUNDLE_ID}`
  ),
  [AppInventoryOption.APP_GROUP]: createAction<CriteriaValue>(
    `${SET_CONTENT_CATEGORY_OP}/${AppInventoryOption.APP_GROUP}`
  ),
};

export const getEmptyInventoryState = (): AppInventoryState => ({
  [AppInventoryOption.APP_BUNDLE_ID]: {
    op: Criteria.ANY,
    val: {},
    inventorylist_id: '',
  },
  [AppInventoryOption.APP_GROUP]: {
    op: Criteria.ANY,
    val: {},
  },
});
